import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { GetSingleProductDetails } from '../../../redux/admin/product/product_services_syn';
import LoaderScreen from '../../../component/loader/loaderScreen';
import { calculateDiscount } from '../../../utils/calculateDiscountPercentage';
import CurrencyFormatter from '../../../component/CurrencyFormatter';
import { PhotoView } from 'react-photo-view';

const DeviceProduct = () => {
  const { productId } = useParams();

  const dispatch = useDispatch();

  const { productDetails, product_loader } = useSelector(
    (state) => state.product
  );

  useEffect(() => {
    dispatch(GetSingleProductDetails({ Id: productId }));
  }, [productId]);

  return (
    <>
      {product_loader && <LoaderScreen />}

      {!product_loader && (
        <div class="row">
          <div class="col-lg-4">
            <div class="card">
              <div class="card-body">
                <div
                  id="carouselExampleFade"
                  class="carousel slide carousel-fade"
                  data-bs-ride="carousel"
                >
                  <div class="carousel-inner" role="listbox">
                    {productDetails?.gallery?.map((item, key) => (
                      <div key={key} class="carousel-item active">
                        <PhotoView
                          src={
                            item?.pic_url || '/assets/images/product/p-1.png'
                          }
                        >
                          <img
                            src={item?.pic_url}
                            alt=""
                            class="img-fluid bg-light rounded"
                          />
                        </PhotoView>
                      </div>
                    ))}
                  </div>
                  <div class="carousel-indicators m-0 mt-2 d-lg-flex d-none position-static h-100">
                    {productDetails?.gallery?.map((item, key) => (
                      <button
                        type="button"
                        data-bs-target="#carouselExampleFade"
                        data-bs-slide-to={key}
                        aria-current="true"
                        aria-label={`Slide ${key + 1}`}
                        class="w-auto h-auto rounded bg-light active"
                      >
                        <img
                          src={item?.pic_url}
                          class="d-block avatar-xl"
                          alt="swiper-indicator-img"
                        />
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="card">
              <div class="card-body">
                <p class="mb-1">
                  <a href="#!" class="fs-24 text-dark fw-medium">
                    {productDetails?.product_name}
                  </a>
                </p>

                <h2 class="fw-medium my-3">
                  {Number(productDetails?.discount) <
                  Number(productDetails?.price) ? (
                    <CurrencyFormatter
                      value={productDetails?.discount}
                      currency={productDetails?.symbol}
                    />
                  ) : (
                    <CurrencyFormatter
                      value={productDetails?.price}
                      currency={productDetails?.symbol}
                    />
                  )}{' '}
                  {Number(productDetails?.discount) <
                    Number(productDetails?.price) && (
                    <>
                      <span class="fs-16 text-decoration-line-through">
                        <CurrencyFormatter
                          value={productDetails?.price}
                          currency={productDetails?.symbol}
                        />
                      </span>
                      <small class="text-danger ms-2">
                        (
                        <>
                          {calculateDiscount(
                            Number(productDetails?.price),
                            Number(productDetails?.discount)
                          )}
                        </>
                        %Off)
                      </small>
                    </>
                  )}
                </h2>

                {productDetails?.colors?.length > 0 && (
                  <div class="row align-items-center g-2 mt-3">
                    <div class="col-lg-3">
                      <div class="flex flex-col gap-2">
                        <h5 class="text-dark fw-medium">{`Colors > `}</h5>
                        <div
                          class="d-flex flex-wrap gap-2"
                          role="group"
                          aria-label="Basic checkbox toggle button group"
                        >
                          {productDetails?.colors?.map((color, index) => (
                            <div
                              key={index}
                              style={{ backgroundColor: color }}
                              className="w-10 h-10 rounded-full border cursor-pointer"
                              title="Click to remove"
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <ul class="d-flex flex-column gap-2 list-unstyled fs-15 my-3">
                  <li>
                    <i class="bx bx-check text-success"></i> In Stock
                  </li>
                  <li>
                    <i class="bx bx-check text-success"></i> Free delivery
                    available
                  </li>
                  {/* <li>
                      <i class="bx bx-check text-success"></i> Sales 10% Off Use
                      Code: <span class="text-dark fw-medium">CODE123</span>
                    </li> */}
                </ul>
                <h4 class="text-dark fw-medium">Description :</h4>
                <p class="text-muted">
                  {productDetails?.description}.{' '}
                  <a href="#!" class="link-primary">
                    Read more
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeviceProduct;
